export enum GameType {
  LIVE = "live",
  PRE_MATCH = "pre-match"
}

export const SCORE_UNAVAILABLE = -1;
